import React from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';

import Loader from 'components/common/Loader';
import Filters from './Filters/Filters';

import styles from './FiltersBar.scss';

const mapStateToProps = (state) => ({
  isLoading: state.objects.isObjectsFetching,
  withClient: state.privacy.withClient,
  currency: state.profile.user_region.country_currency_symbol
});

const FiltersBar = ({ className, isLoading, withClient, currency }) => (
  <div className={cn(styles.FiltersBar, className, withClient && styles.withClient)}>
    <Filters currency={currency} />
    <Loader active={isLoading} />
  </div>
  );

export default connect(mapStateToProps)(FiltersBar);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/FiltersBar.js